import UUID from 'uuid/v5';
import UUIDv4 from 'uuid/v4';

export const createUUID = () => {
  return UUID(Date.now().toString(), UUIDv4());
};
